import { Injectable } from '@angular/core';

/**
 * Configuration service for the lfDropdown directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the dropdowns used in the application.
 */
@Injectable({
    providedIn: 'root',
})
export class LFDropdownConfig
{
    up = false;
    autoClose = true;
}
